import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const originalAuthorAvatarUrlResolver: FieldResolver = (metadata: Metadata) =>
  ({ originalAuthorAvatarUrl: metadata.getOriginalAuthorAvatarUrl() } as StreamData)

export default originalAuthorAvatarUrlResolver
